module.exports = __webpack_public_path__ + "img/355509.85c3d7af.jpg";